export default "__VITE_ASSET__K3tFFpNH__"